import Button from '../../../../../../components/buttons/Button';
import React from 'react';
import { isEmpty } from 'lodash';
import { getElementIdsForLabelUpdate, getHighestLabelBoardId, partitionLabelRootsByEditability } from '../labelUtils';
import { deleteLabel, updateLabel } from '../../../../../../../common/labels/labelActions';
import { replaceLabelIdForElementsThunk } from '../labelThunks';
import { useDispatch } from 'react-redux';
import {
    BoardVirtualPathMap,
    LabeledElementsData,
} from '../../../../../../../common/api/labels/labelElementsRetrievalRouteTypes';
import { Label } from '../../../../../../../common/labels/labelTypes';
import { ImMNElement } from '../../../../../../../common/elements/elementModelTypes';

type Props = {
    label: Label | null;
    labeledElements: LabeledElementsData[] | null;
    userRootPath: ImMNElement[] | null;
    boardVirtualPathToRootMap: BoardVirtualPathMap | null;
    translate: (key: string, options?: Record<string, any>) => string;
};

const LabelDeleteButton = (props: Props) => {
    const { label, labeledElements, userRootPath, boardVirtualPathToRootMap, translate } = props;

    const dispatch = useDispatch();

    const elementCount = isEmpty(labeledElements) || !labeledElements ? 0 : labeledElements.length;

    const deleteLabelHandler = () => {
        if (!label || !userRootPath || !boardVirtualPathToRootMap) return;

        // Check if all label roots fall under the current highest label root
        const { labelRootsNotToUpdate } = partitionLabelRootsByEditability(
            label,
            userRootPath,
            boardVirtualPathToRootMap,
        );

        // If so, make the update
        if (labelRootsNotToUpdate.length === 0) {
            dispatch(deleteLabel(label.id));
            return;
        }

        // if not,
        // Remove those label roots from the old label
        dispatch(updateLabel(label.id, { rootBoardIds: labelRootsNotToUpdate }));

        // Remove the label id from all labeled elements for those roots

        const highestRootId = getHighestLabelBoardId(label, userRootPath);
        const elementIdsForUpdate = getElementIdsForLabelUpdate(
            labeledElements || [],
            highestRootId,
            boardVirtualPathToRootMap,
        );
        dispatch(replaceLabelIdForElementsThunk(elementIdsForUpdate, label.id));
    };

    return (
        <Button className="flex w-48 !mx-6 !py-1 !px-4 hover:!bg-gray-100" onClick={deleteLabelHandler}>
            <div className="flex w-full items-center justify-between gap-4">
                <span>{translate('delete')}</span>
                {elementCount > 0 && (
                    <span className="text-xs text-gray-400">{translate('used', { count: elementCount })}</span>
                )}
            </div>
        </Button>
    );
};

export default LabelDeleteButton;
